export default class HomeBannerLoader {
	constructor(root) {
		this.el = root.querySelector(".banner-home-loader");
		this.gridEl = root.querySelector(".banner-home-loader-grid");
		this.dots = [];
		this.rippleInterval = null;

		if (!this.el || !this.gridEl) return;

		for (let r = 0; r < 5; r++) {
			for (let c = 0; c < 5; c++) {
				const dot = document.createElement("span");
				this.gridEl.appendChild(dot);
				this.dots.push({ element: dot, dist: Math.abs(r - 2) + Math.abs(c - 2) });
			}
		}
	}

	startRipple() {
		if (!this.dots.length) return;
		this.runRipple();
		this.rippleInterval = setInterval(() => this.runRipple(), 1500);
	}

	runRipple() {
		this.dots.forEach((d) => d.element.classList.remove("ripple"));
		[
			{ d: 0, t: 0 },
			{ d: 1, t: 150 },
			{ d: 2, t: 300 },
			{ d: 3, t: 450 },
			{ d: 4, t: 600 },
		].forEach((p) => {
			setTimeout(() => {
				const wave = this.dots.filter((d) => d.dist === p.d);
				wave.forEach((d) => d.element.classList.add("ripple"));
				setTimeout(() => wave.forEach((d) => d.element.classList.remove("ripple")), 250);
			}, p.t);
		});
	}

	hide() {
		if (this.rippleInterval) clearInterval(this.rippleInterval);
		if (!this.el) return;

		if (!this.dots.length) {
			this.el.style.opacity = "0";
			setTimeout(() => (this.el.style.display = "none"), 400);
			return;
		}

		this.dots.forEach((d) => d.element.classList.remove("ripple"));
		[0, 1, 2, 3, 4].forEach((dist) => {
			setTimeout(() => {
				this.dots.filter((d) => d.dist === dist).forEach((d) => d.element.classList.add("erase"));
			}, dist * 150);
		});
		setTimeout(() => (this.el.style.display = "none"), 4 * 150 + 400);
	}
}
